import React, { useState, useEffect } from 'react';
import Lottie from 'lottie-react';
import PropTypes from 'prop-types';

import { Box, Typography } from '@mui/material';

import stylesDef from './styles';
import animation from './lottie.json';

const Loading = ({ loading, fullScreen = true, width = 200, height = 200, timeout = 30000, onTimeout = () => {}, timeoutMessage = '' }) => {
    const styles = fullScreen ? stylesDef.loading : {};

    const [timedout, setTimedout] = useState(false);

    useEffect(
        () => {
            if (loading) {
                let timer = setTimeout(() => {
                    setTimedout(true);
                    onTimeout();
                }, timeout);

                return () => {
                    clearTimeout(timer);
                };
            }
        }, [],
    );

    if (loading && !timedout) {
        return (
            <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', ...styles }}>
                <Lottie
                    animationData={animation}
                    loop={true}
                    style={{
                        width: width,
                        height: height,
                    }}
                />
            </Box>
        );
    } else if (loading && timedout) {
        return (
            <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Typography p={1} m={1} sx={{ fontWeight: 500 }}>
                    {timeoutMessage}
                </Typography>
            </Box>
        );
    }

    return null;
};

Loading.propTypes = {
    loading: PropTypes.bool,
    fullScreen: PropTypes.bool,
    width: PropTypes.number,
    height: PropTypes.number,
    timeout: PropTypes.number,
    onTimeout: PropTypes.func,
    timeoutMessage: PropTypes.string,
};

export default Loading;
